import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { settingsConfig } from 'components/Settings/settingsConfig';
import { Integrations } from 'components/pages/IntegrationsPage/components/Integrations/Integrations';

export const IntegrationsPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.integrations.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.integrations.title} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <Integrations />
            </MainContent>
        </PageContainer>
    );
};
